export { FeatureElectricCars } from "./lib/landing-feature-electric-cars";
export { getStaticProps } from "./lib/get-static-props";
